import type { ReactNode } from 'react';
import styled from 'styled-components';
import { Tag } from '../../Tag';
import { formControlCSS } from '../styles';
import type { FormControlProps, FormControlSizes } from '../types';

export const MultiSelectWrapper = styled.div`
  position: relative;
`;

export const Selection = styled(Tag)<{ disabled: boolean; suffix?: ReactNode; formControlSize: FormControlSizes }>`
  border-radius: ${({ theme }) => theme.borderRadiusSmall}px;
  white-space: nowrap;
  position: relative;
  padding-right: ${({ suffix, theme, formControlSize }) =>
    suffix ? `${(formControlSize / 2) * theme.spacing24}px` : ''};
  padding-left: ${({ suffix, theme, formControlSize }) =>
    suffix ? `${(formControlSize / 2) * theme.spacing4}px` : ''};
  height: ${({ theme, formControlSize }) => theme.baseSize * (formControlSize - 0.5)}px;

  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
`;

export const MultiSelectInputWrapper = styled.label<FormControlProps<HTMLInputElement>>`
  ${formControlCSS}
  justify-content: space-between;
  padding-top: ${({ theme }) => theme.spacing2}px;
  padding-bottom: ${({ theme }) => theme.spacing2}px;
  padding-left: ${({ theme }) => theme.spacing2}px;

  height: auto;
  max-width: 100%;

  i {
    line-height: 1;
  }

  input {
    min-width: 50px;
    padding-left: ${({ theme }) => theme.spacing8 - theme.spacing2}px;
    line-height: 1.5;
  }
`;
